import type { MapState } from './map'

import { snapshot, useSnapshot } from 'valtio'
import { initialLockedValue, initialSelectionModeValue, mapAtom } from './map'

type PublicMapState = Pick<MapState, 'locked' | 'selectionMode'>

type SetMap = (prev: PublicMapState) => PublicMapState
type SetMapParam = SetMap | Partial<PublicMapState> | 'reset'

// ------------------------------------
// Write functions
// ------------------------------------

export const setMap = (valueOrFunc: SetMapParam) => {
  // reset
  if (valueOrFunc === 'reset') return resetMap()

  // callback with prev value
  if (typeof valueOrFunc === 'function') {
    const updates = valueOrFunc(snapshot(mapAtom))

    for (const field of Object.keys(updates)) {
      mapAtom[field] = updates[field]
    }
  } else {
    // atomic update
    for (const field of Object.keys(valueOrFunc)) {
      mapAtom[field] = valueOrFunc[field]
    }
  }

  return mapAtom
}

export const resetMap = () => {
  mapAtom.locked = initialLockedValue
  mapAtom.selectionMode = initialSelectionModeValue

  return mapAtom
}

// ------------------------------------
// Read functions
// ------------------------------------

export function isMapLocked() {
  return mapAtom.locked
}

// ------------------------------------
// React Hooks
// ------------------------------------

export const useMap = () => {
  return [useSnapshot(mapAtom), setMap] as const
}
export const useMapInstance = () => {
  return mapAtom.map
}
